import React, { useContext, useState, useEffect, useMemo } from 'react'

import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'

import { t } from 'i18next'
import View from 'src/components/atoms/View'
import Text from 'src/components/atoms/TextNew'
import Button from 'src/components/atoms/Button'
import Input from 'src/components/atoms/Input'
import NewSelect from 'src/components/atoms/NewSelect'
import { SelectOption } from 'src/components/atoms/SelectInput'
import { createTransport } from 'src/helpers/api/createTransport'
import Space from 'src/components/atoms/Space'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_SPEDITIONS } from 'dealer-reducers'
import { RootReducer } from 'src/redux/rootReducer'

interface Props {
  offerId: number
}

const TransportBar = ({ offerId }: Props): JSX.Element => {
  const dispatch = useDispatch()
  const speditions = useSelector((state: RootReducer) => state.speditionsReducer.speditions)
  useEffect(() => {
    dispatch(FETCH_SPEDITIONS())
  }, [dispatch])

  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)

  const [transportNote, setTransportNote] = useState('')
  const [selectedSpeditionId, setSelectedSpeditionId] = useState<string | number>('')

  const speditionOptions: SelectOption[] = useMemo(
    () => [
      { optionVal: '', optionLabel: t('in_realization_list_item.choose_spedition') },
      ...speditions.map((s) => ({ optionVal: s.id, optionLabel: s.name }))
    ],
    [speditions]
  )

  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  return (
    <View
      onClick={(e) => {
        e.stopPropagation()
      }}
      className="px-6 flex justify-between cursor-auto shadow-bothMedium rounded-b-4 bg-gradient-to-b from-blueGradientStart to-blueGradientStop">
      <View className="w-[300px] flex flex-col justify-center items-center gap-3">
        <View className="w-full">
          <NewSelect
            label={t('in_realization_list_item.choose_spedition')}
            value={selectedSpeditionId}
            onChange={(val) => {
              setSelectedSpeditionId(typeof val === 'boolean' ? '' : val)
            }}
            options={speditionOptions}
            containerStyles={{
              width: '300px',
              height: '41px'
            }}
            optionsContainerStyles={{
              width: '300px'
            }}
          />
        </View>
      </View>
      <View className="w-[300px] flex justify-center items-center text-center text-darkGrey">
        <Input
          label={t('in_realization_list_item.spedition_note')}
          value={transportNote}
          onChange={(e) => {
            setTransportNote(e.target.value)
          }}
          customInputStyles={{
            borderRadius: '5px',
            height: '41px'
          }}
        />
      </View>

      <View className="flex flex-col justify-end gap-2">
        <Space y={2} />
        <View className="flex gap-4 justify-end items-center">
          <Button
            color="transparent"
            variant="medium"
            onClick={() => {
              dispatchItemContext({ type: 'TOGGLE_VIEW' })
              dispatchItemContext({ type: 'SET_BAR', payload: 'pick_up' })
            }}>
            <Text className="text-xl text-white font-SemiBold">
              <>{t('auction_contract_modal.resign')}</>
            </Text>
          </Button>
          <Button
            variant="medium"
            onClick={() => {
              if (selectedSpeditionId === '' || typeof selectedSpeditionId !== 'number') {
                return
              }
              createTransport({
                offerId,
                description: transportNote,
                speditionId: selectedSpeditionId
              })
                .then(() => {
                  dispatchItemContext({ type: 'CREATE_TRANSPORT_SUCCESS' })
                })
                .catch(() => {
                  dispatchItemContext({ type: 'CREATE_TRANSPORT_FAILURE' })
                })
            }}>
            <Text className="text-xl  text-white font-SemiBold">
              <>{t('in_realization_list_item.create_transport_button')}</>
            </Text>
          </Button>
        </View>
        <View
          className="flex gap-1 justify-center text-center text-m text-white max-w-[400px]"
          dangerouslySetInnerHTML={{
            __html: t('in_realization_list_item.spedition_terms_1')
          }}
        />
        <Space y={2} />
      </View>
    </View>
  )
}

export default TransportBar
